import Card from '@mui/material/Card';
import Divider, { dividerClasses } from '@mui/material/Divider';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatBoldIcon from '@mui/icons-material/FormatBold';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Card": Card, "@mui/material/Divider": Divider, "@mui/icons-material/FormatAlignLeft": FormatAlignLeftIcon, "@mui/icons-material/FormatAlignCenter": FormatAlignCenterIcon, "@mui/icons-material/FormatAlignRight": FormatAlignRightIcon, "@mui/icons-material/FormatBold": FormatBoldIcon } } });
export default ClientProvider;
